<div class="app-shell">
  <app-header></app-header>

  <main class="app-shell__content">
    @if (checkDone()) {
      <router-outlet></router-outlet>
    }
  </main>

  <app-footer></app-footer>
</div>
<app-toast></app-toast>
